const map = {
	"./Data protection-emcomy-desktop.webp": 57816,
	"./Data protection-emcomy.webp": 56177,
	"./Imprint-emcomy-desktop.webp": 28198,
	"./Imprint-emcomy.webp": 55683,
	"./Terms of use-emcomy-desktop.webp": 35570,
	"./Terms of use-emcomy.webp": 31943,
	"./de.webp": 94642,
	"./dead_DE.webp": 81407,
	"./dead_EN.webp": 90647,
	"./dead_ES.webp": 22688,
	"./dead_PT.webp": 74648,
	"./dead_PTBR.webp": 89292,
	"./emcomyLogo-pt.webp": 22847,
	"./emcomyLogoWhite.webp": 43253,
	"./emcomyLogoWhiteCut.webp": 22535,
	"./en.webp": 12650,
	"./es.webp": 99817,
	"./green-wave.webp": 9922,
	"./halfPTBR.webp": 79032,
	"./hospital_DE.webp": 96803,
	"./hospital_EN.webp": 65915,
	"./hospital_ES.webp": 60188,
	"./hospital_PT.webp": 60868,
	"./hospital_PTBR.webp": 78264,
	"./private-message-icons/private-message-01.webp": 99797,
	"./private-message-icons/private-message-02.webp": 7368,
	"./private-message-icons/private-message-03.webp": 47275,
	"./private-message-icons/private-message-04.webp": 89510,
	"./pt.webp": 94289,
	"./ptBR.webp": 47905
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;